export const PART_MODE = {
	CUSTOM: 'custom',
	SELECT: 'select',
}
